import { CookieLockIcon } from './CookieLockIcon';

/**
 * author: Colton Wiscombe
 * id FD4F6EA6-712D-4E1E-AF1E-25CB27AE66CE
 * name cookie-lock
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cookie-lock.svg
 * tags
 * - Food / Drink 
 * - Lock 
 */
export const BiscuitLockIcon = CookieLockIcon;
export default BiscuitLockIcon